export enum ReCaptchaState {
  OK,
  Error_Unchecked,
  Error_Failed,
}